import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BadgePercent, Check } from 'lucide-react';
import { API } from '../../lib/api';

// Launch offer banner + optional discount code on the workshop sign-up form.
export const SignupDiscount = ({ code, onCode, fieldCls }) => {
  const [offer, setOffer] = useState(null);
  const [checked, setChecked] = useState(null);
  const [open, setOpen] = useState(false);
  const check = async (value = code) => {
    if (!value.trim()) { setChecked(null); return; }
    try { const { data } = await axios.get(`${API}/public/discount-code/${encodeURIComponent(value.trim())}`); setChecked({ ok: true, ...data }); }
    catch { setChecked({ ok: false }); }
  };
  useEffect(() => {
    axios.get(`${API}/public/signup-offer`).then((r) => setOffer(r.data)).catch(() => {});
    // A shared Refer & Earn link arrives as /get-started?ref=CODE.
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) { const c = ref.toUpperCase(); onCode(c); setOpen(true); check(c); }
  }, []); // eslint-disable-line
  return (
    <div className="space-y-2">
      {offer?.enabled && (
        <div className="flex items-center gap-2 rounded-xl bg-teal-50 border border-teal-200 px-3 py-2 text-sm text-teal-900" data-testid="signup-offer-banner">
          <BadgePercent size={16} className="text-teal-600 shrink-0" />
          <span><b>{offer.percent}% off</b> for your first {offer.months} months{offer.note ? ` · ${offer.note}` : ''} — applied automatically.</span>
        </div>
      )}
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} className="text-xs font-semibold text-slate-600 underline hover:text-slate-900" data-testid="signup-have-code">Have a discount code?</button>
      ) : (
        <div>
          <input value={code} onChange={(e) => { onCode(e.target.value.toUpperCase()); setChecked(null); }} onBlur={() => check()} placeholder="Discount code" className={fieldCls} data-testid="signup-discount-code" />
          {checked?.ok && <p className="mt-1 text-xs text-teal-700 inline-flex items-center gap-1" data-testid="signup-code-ok"><Check size={12} /> {checked.percent}% off for {checked.months} months will be applied.</p>}
          {checked && !checked.ok && <p className="mt-1 text-xs text-red-600" data-testid="signup-code-bad">This code is not valid or has expired.</p>}
        </div>
      )}
    </div>
  );
};
